import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import styled from "styled-components";
import colors from '@Constants/colors';
import { Button } from 'react-bootstrap';


const Icon = styled(Button)`
  background-color: ${colors.WHITE};
  border-color: ${colors.TERTIARY};
  border-radius: 50%;
  position: absolute;
  bottom: 75px;
  right: 15px;
  z-index:20000;
  width: 55px;
  padding: 15px 0;

  &:hover{
    border-color: ${colors.TERTIARY};
    background-color: ${colors.TERTIARY};
  }

`;

const SearchIcon = styled(FontAwesomeIcon)`
  color: ${colors.TERTIARY};
  
  &:hover{
    color: ${colors.WHITE};
  }
`;

function RoundIconSearch({show, click}) {

  const ChangeOnHover =()=>{
    document.getElementById('RoundIconSearch').style.color = colors.WHITE;
  }
  const ChangeOnOut =()=>{
    document.getElementById('RoundIconSearch').style.color = colors.TERTIARY;
  }

  return (
    <>
        {show &&
        <Icon onMouseOver={ChangeOnHover} onMouseOut={ChangeOnOut} onClick={click}>
          <SearchIcon id="RoundIconSearch" icon={faFilter} size="lg"/>
        </Icon>}
    </>
  );
}

export default RoundIconSearch;